import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    searchText: '',
    tag: 'All'
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        tagSelected: (state, action) => {
            state.tag = action.payload;
        },
        searchedBy: (state, action) => {
            state.searchText = action.payload;
        }
    }
});

export default filterSlice.reducer;
export const { tagSelected, searchedBy } = filterSlice.actions;